//import Home from '../controllers/home'

// Single pages
import Login from '../controllers/single/login'
import Visitante from '../controllers/single/visitante'
import Code from '../controllers/single/code'
import Savio from '../controllers/single/savio'
import Logout from '../controllers/single/logout'

// Encuestas
import Caracterizacion from '../controllers/encuestas/caracterizacion'
import Dinamica from '../controllers/encuestas/dinamica'
import Gracias from '../controllers/encuestas/gracias'
import EncuestaInactiva from '../controllers/encuestas/EncuestaInactiva'
import CodigoEnviado from '../controllers/encuestas/codigoEnviado'
import CodigoNoEnviado from '../controllers/encuestas/codigoNoEnviado'
import CodigoAlertas from '../controllers/encuestas/CodigoAlertas'

export default [
    //{
    //    path: '/',
    //    name: 'home',
    //    component: Home
    //},
    {
        path: '/',
        redirect: { name: 'encuesta-inactiva' }
    },
    {
        path: '/periodica',
        redirect: { name: 'encuesta-inactiva' }
    },
    {
        path: '/code',
        name: 'code',
        component: Code
    },
    {
        path: '/savio',
        name: 'savio',
        component: Savio
    },
    {
        path: '/logout',
        name: 'logout',
        component: Logout
    },
    {
        path: '/caracterizacion',
        name: 'caracterizacion',
        component: Caracterizacion,
        meta: {
            external: true
        }
    },
    {
        path: '/dinamica/:id',
        name: 'dinamica',
        component: Dinamica,
        meta: {
            external: true
        }
    },
    {
        path: '/gracias',
        name: 'gracias',
        component: Gracias,
        meta: {
            external: true
        }
    },
    {
        path: '/encuesta-inactiva',
        name: 'encuesta-inactiva',
        component: EncuestaInactiva,
        meta: {
            external: true
        }
    },
    {
        path: '/codigo-enviado',
        name: 'codigoEnviado',
        component: CodigoEnviado,
        meta: {
            external: true
        }
    },
    {
        path: '/codigo-no-enviado',
        name: 'codigoNoEnviado',
        component: CodigoNoEnviado,
        meta: {
            external: true
        }
    },
    {
        path: '/codigo-alertas',
        name: 'codigoAlertas',
        component: CodigoAlertas,
        meta: {
            external: true
        }
    },
    {
        path: '/login',
        name: 'login',
        component: Login
    },
    {
        path: '/visitante',
        name: 'visitante',
        component: Visitante
    }
]